import * as types from './constants';

export const changeLocale = (languageLocale) => {
  return {
    type: types.CHANGE_LOCALE,
    locale: languageLocale,
  };
};
export const deviceLocale = (locale) => {
  return {
    type: types.DEVICE_LOCALE,
    locale: locale,
  };
};
export const getDataTrans = (data) => {
  return {
    type: types.GET_DATA_TRANS,
    payload: data,
  };
};
export const changeLangList = (data) => {
  return {
    type: types.CHANGE_LOCALE_LIST,
    payload: data,
  };
};
export const updateJsonLang = (data) => {
  return {
    type: types.UPDATE_JSON_LANG,
    payload: data,
  };
};
